import Discussion from './Discussion.container';

export default Discussion;
